import React, { FocusEvent, Dispatch, SetStateAction } from "react";
import DatePicker from "react-datepicker";
import { dayjs } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  start_date: Date | null;
  end_date: Date | null;
  handleChange: (dates: [any, any]) => void;
  setStartDate: Dispatch<SetStateAction<Date | null>>;
  setEndDate: Dispatch<SetStateAction<Date | null>>;
};
const now = dayjs().endOf("day").toDate();
function DateSelectorComponent(props: AllProps) {
  const { start_date, end_date, handleChange, setStartDate, setEndDate } = props;

  // Description: adjust date on blur
  const handleBlur = (event: FocusEvent<HTMLInputElement, Element>, start: boolean) => {
    const input = event.target.value;
    if (input) {
      const date = dayjs(new Date(input).toISOString());
      if (start) {
        if (date.isValid() && !!end_date && date.toDate() < end_date && date < dayjs()) {
          setStartDate(date.startOf("day").toDate());
        }
      } else {
        if (date.isValid() && !!start_date && date.toDate() > start_date && date < dayjs()) {
          setEndDate(date.endOf("day").toDate());
        }
      }
    }
  };

  const DateSelector = () => {
    return <div className="date-selector">
      <div className="date-picker-inputs p-2">
        <div className="date-picker-input">
          <span>
            <Icon className="pv-icon-calendar text-muted " />
          </span>
          <DatePicker
            autoFocus={!start_date}
            focusSelectedMonth={false}
            className="border-0 input"
            selected={start_date}
            startDate={start_date}
            onChange={(date) => setStartDate(date)}
            onBlur={(e) => handleBlur(e, true)}
            selectsStart
            popperClassName="d-none"
            dateFormat={["MMM d, yyyy", "MMM dd, yyyy"]}
            placeholderText="Select start date"
            maxDate={now}
            shouldCloseOnSelect={false}
            autoComplete={"off"}
          />
        </div>
        <div className="date-picker-input">
          <span>
            <Icon className="pv-icon-calendar text-muted" />
          </span>
          <DatePicker
            focusSelectedMonth={false}
            className="border-0 input"
            selected={end_date}
            startDate={start_date}
            endDate={end_date}
            onChange={(date) => setEndDate(date)}
            onBlur={(e) => handleBlur(e, false)}
            selectsEnd
            popperClassName="d-none"
            dateFormat={["MMM d, yyyy", "MMM dd, yyyy"]}
            placeholderText="Select end date"
            minDate={start_date}
            maxDate={now}
            shouldCloseOnSelect={false}
            autoComplete={"off"}
          />
        </div>
      </div>
      <DatePicker
        focusSelectedMonth={false}
        calendarClassName="logs"
        dateFormat="MMM d, yyyy"
        selected={start_date}
        startDate={start_date}
        endDate={end_date}
        onChange={handleChange}
        monthsShown={2}
        selectsRange={true}
        shouldCloseOnSelect={false}
        maxDate={now}
        inline
        autoComplete="off"
      />
    </div>;
  };

  return <DateSelector />;
}

export default React.memo(DateSelectorComponent);